import { authQuery } from './Authquery'
import BaseService from './BaseService'


const ApiService = {
    fetchData(param, signal) {
        return new Promise((resolve, reject) => {
            BaseService(param, { signal }).then(response => {
                resolve(response)
            }).catch(errors => {
                reject(errors)
            })
        })
    }
}

export default ApiService

export const NoAuthService = {
  fetchData(param) {
    return new Promise((resolve, reject) => {
      authQuery(param)
        .then((response) => {
          resolve(response);
        })
        .catch((errors) => {
          reject(errors);
        });
    });
  },
};